import * as Sentry from '@sentry/vue'

/** Rising-edge dedupe so pending-commit retries (~1.2s) do not spam breadcrumbs. */
let episodeOpen = false

const MAX_URNS_IN_BREADCRUMB = 20

/**
 * One breadcrumb per incomplete-campaign-asset rematerialize episode (#1574).
 * Filter in Sentry: category `incomplete_campaign_asset_rematerialize`.
 */
export function reportIncompleteCampaignAssetRematerializeToSentry(input: {
  reason: string
  incompleteUrns: readonly string[]
}): void {
  if (input.incompleteUrns.length === 0) {
    return
  }
  if (episodeOpen) {
    return
  }
  episodeOpen = true
  try {
    Sentry.addBreadcrumb({
      category: 'incomplete_campaign_asset_rematerialize',
      message: 'incomplete_campaign_asset_rematerialize',
      level: 'warning',
      data: {
        reason: input.reason,
        incompleteCount: input.incompleteUrns.length,
        incompleteUrns: input.incompleteUrns.slice(0, MAX_URNS_IN_BREADCRUMB)
      }
    })
  }
  catch {
    /* Sentry not initialized or unavailable */
  }
}

/** Call when the incomplete-list condition clears (assets present or left-campaign abandon). */
export function clearIncompleteCampaignAssetRematerializeSentryDedupe(): void {
  episodeOpen = false
}

/** Test-only reset of dedupe state. */
export function resetIncompleteCampaignAssetRematerializeSentryDedupeForTests(): void {
  episodeOpen = false
}
